import { IQuery, IQueryMediator } from 'core-ts-types';
import * as moment from 'moment';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentType, IAvailable, IAvailableTime, IStudentService } from '../types/appointment_interfaces';
import { ILocation } from '../types/appt_interfaces';
import { TAppointmentAvailableTimesUsersource } from '../usersources/appointment_available_times_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

import * as _4 from 'lodash4';

interface IAppointmentsConfirmQueryResult {
  when: string;
  appointmentType: string;
  who: string;
  why: string;
  location: string;
  organizerType: string;
  startTimeUnix: string;
  endTimeUnix: string;
  organizer: IAvailable;
  selectedService: IStudentService;
  isCampaignAppointment: boolean;
  additionalDetails: string;
  meetingUrlOrPhone: string;
}

export class AppointmentsConfirmQuery implements IQuery {
  private _result: IAppointmentsConfirmQueryResult;

  constructor(
    private ngAppointmentAvailableTimesUsersource: TAppointmentAvailableTimesUsersource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private accountModel: any,
    private appointmentCampaignConstant: any
  ) {
    ORMMediator.registerQuery(this, ngAppointmentAvailableTimesUsersource);
  }

  get studentFullName(): string {
    return `${this.accountModel.firstName} ${this.accountModel.lastName}`;
  }

  run(): this {
    const selectedTimeDetails = this.ngAppointmentAvailableTimesUsersource.read().selectedTimeDetails;
    let when: string = '';
    let appointmentType: string = '';
    let who: string = '';
    let why: string = '';
    let location: string = '';
    let organizerType: string = '';
    let organizer: IAvailable = {} as IAvailable;
    let startTimeUnix: string = '';
    let endTimeUnix: string = '';
    let additionalDetails: string = '';
    let meetingUrlOrPhone: string = '';
    const isCampaignAppointment = this.appointmentCampaignConstant.isAppointmentCampaign;

    if (!_4.isEmpty(selectedTimeDetails)) {
      organizer = selectedTimeDetails.available;
      additionalDetails = selectedTimeDetails.details;
      [startTimeUnix, endTimeUnix] = _4.split(selectedTimeDetails.range, '_');
      const startTime = moment.unix(_4.toNumber(startTimeUnix)).format('ddd, MMM DD YYYY - hh:mm A');
      const endTime = moment.unix(_4.toNumber(endTimeUnix)).format('hh:mm A');
      when = `${startTime}-${endTime}`;
      appointmentType = this.ngAppointmentReasonUsersource.read().selectedType.name;
      who = `${this.studentFullName} with ${organizer.first_name} ${organizer.last_name}`;
      why = this.ngAppointmentReasonUsersource.read().selectedService.name;
      location = selectedTimeDetails.location;
      organizerType = this.ngAppointmentReasonUsersource.read().selectedType.organizer_name;
      meetingUrlOrPhone = _4.get(selectedTimeDetails, 'meeting_url_or_phone', '');
    }

    this._result = {
      when,
      appointmentType,
      who,
      why,
      location,
      organizerType,
      startTimeUnix,
      endTimeUnix,
      organizer,
      selectedService: this.ngAppointmentReasonUsersource.read().selectedService,
      isCampaignAppointment,
      additionalDetails,
      meetingUrlOrPhone
    };

    return this;
  }

  get result(): IAppointmentsConfirmQueryResult {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_confirm_query.ts